import React from "react";

import { RowData, Table as TSTableType } from "@tanstack/react-table";

import { EmptyTableBox } from "../../Table/EmptyTableBox";
import { NoResults } from "../../Table/NoResults";
import { StickyHeaderOverflowTable } from "../../Table/StickyHeaderOverflowTable";

import { TSTRows } from "./TSTBody";
import { TSTHead } from "./TSTHead";

interface TSTTableProps<T extends RowData> {
    table: TSTableType<T>;
    noResultsFallback: React.ReactNode;
    noSourceRowsFallback: React.ReactNode;
    /** A `<TableToolbar>`, pinned alongside the head instead of scrolling away. */
    toolbar?: React.ReactNode;
    tableRef?: React.RefObject<HTMLDivElement | null>;
}
export function TSTTable<T extends RowData>({
    table,
    noResultsFallback,
    noSourceRowsFallback,
    toolbar,
    tableRef,
}: TSTTableProps<T>) {
    const hasSourceRows = table.options.data.length > 0;
    const hasRows = table.getRowModel().rows.length > 0;

    if (!hasRows) {
        return (
            <>
                {toolbar}
                <EmptyTableBox>
                    <NoResults
                        description={
                            hasSourceRows
                                ? noResultsFallback
                                : noSourceRowsFallback
                        }
                    />
                </EmptyTableBox>
            </>
        );
    }
    return (
        <StickyHeaderOverflowTable
            tableRef={tableRef}
            bodyComponent={<TSTRows table={table} />}
            headComponent={<TSTHead table={table} />}
            contentWidth={table.getTotalSize()}
            toolbarComponent={toolbar}
        />
    );
}
